import { FunctionComponent, memo } from "react";
import { useFormikContext } from "formik";
import { faUndo } from "@fortawesome/pro-solid-svg-icons";
import { Button, Tooltip } from "@edgetier/components";

/**
 * Component for a reset button to reset form filters.
 * @returns {JSX.Element} ResetButton component.
 */
const ResetButton: FunctionComponent<{}> = () => {
    const { dirty, resetForm } = useFormikContext();
    return (
        <Tooltip content={"Reset Filters"} delayEnter={750}>
            <Button
                data-testid="filters-reset-button"
                disabled={!dirty}
                aria-label="reset filters"
                icon={faUndo}
                onClick={() => {
                    resetForm();
                }}
                type="submit"
                isIconOnly
            />
        </Tooltip>
    );
};

export default memo(ResetButton);
